import React, { useState } from "react";
import { Modal, Input } from "antd";
import { toast } from "react-toastify";
import { customLogger } from "../../../../utils/Logger";
import { useAddNewNumberUnansweredMutation } from "../../../../redux/services/settingsApi";
import GradientButton from "../../../common/UI/GradientButton";
import "./index.scss";

interface AddNewModalProps {
  visible: boolean;
  onClose: () => void;
  onAfterClose: () => void;
}

const AddNewUnansweredModal: React.FC<AddNewModalProps> = ({
  visible,
  onClose,
  onAfterClose,
}) => {
  const [addNewNumberUnanswered, { isLoading }] =
    useAddNewNumberUnansweredMutation();
  const [phoneNumber, setCurrentPhoneNumber] = useState<any>(null);

  const handleCreate = async () => {
    if (
      !phoneNumber ||
      phoneNumber.length > 13 ||
      /[a-zA-Z]/.test(phoneNumber.replace(/^\+/, ""))
    ) {
      toast.error("Please enter a valid phone number");
      return;
    }

    try {
      await addNewNumberUnanswered({
        phoneNumber: phoneNumber.startsWith("+")
          ? phoneNumber
          : `+${phoneNumber}`,
      }).unwrap();

      toast.success("Phone Number added successfully!");
      onClose();
    } catch (err: any) {
      customLogger(err);
      toast.error(err?.data?.message || "There was an error. Please try again");
    }
  };

  return (
    <Modal
      title="Add new"
      open={visible}
      onCancel={onClose}
      afterClose={onAfterClose}
      footer={null}
      centered
      width={300}
      className="block-number-modal custom-modal"
    >
      <Input
        className="number-input"
        value={phoneNumber}
        onChange={(e) => setCurrentPhoneNumber(e.target.value)}
      />
      <GradientButton loading={isLoading} onClick={handleCreate}>
        Add
      </GradientButton>
    </Modal>
  );
};

export default AddNewUnansweredModal;
